import React, { useEffect, useState } from "react";

const TabComponent = ({ tabs, onTabClick, selectedRadio }) => {
  // Default to selectedRadio if provided, otherwise use first tab, fallback to third if available
  const defaultTab = selectedRadio || tabs?.[0]?.value || tabs?.[2]?.value;
  const [activeTab, setActiveTab] = useState(defaultTab);
  console.log({ tabs, activeTab, selectedRadio });

  useEffect(() => {
    // Update activeTab based on selectedRadio
    const matchingTab = tabs.find((tab) => tab.value === selectedRadio);
    if (matchingTab) {
      setActiveTab(matchingTab.value);
    }
  }, [selectedRadio, tabs]);

  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
    onTabClick(tabName);
  };

  return (
    <div>
      <div className="justify-center space-x-0.5 text-xs">
        {tabs.map((tab, index) => (
          <button
            key={tab.value}
            className={`px-2 py-2
			${index == 0 ? "rounded-tl-[7px] rounded-bl-[7px]" : "rounded-none"}
            ${
              index === 4 ? "rounded-tr-[7px] rounded-br-[7px]" : "rounded-none"
            }
            ${
              activeTab === tab.value
                ? "bg-yellow-500  text-white"
                : "bg-yellow-100 text-black"
            } 
								`}
            onClick={() => handleTabChange(tab.value)}
          >
            {tab.title}
          </button>
        ))}
      </div>
      {/* <div className="mt-4 p-4 border border-gray-300">
        {tabs.map((tab) => (
          <div key={tab.key} style={{ display: activeTab === tab.key ? 'block' : 'none' }}>
            {tab.content}
          </div>
        ))}
      </div> */}
    </div>
  );
};

export default TabComponent;
